<template>
    <div class="my-1" v-if="Object.keys($store.state.healthyHabits.table.data).length > 0">
      <div class="current-month-table" :class="{'current-month-table-mobile': mobileVersion()}">{{currentMonthName}}</div>
      <b-table :id="id" v-sortable="sortableOptions" v-touch:swipe.left="tableSwipe" v-touch:swipe.right="tableSwipe" :tbody-tr-attr="trAttributes" :key="`healthyHabitsTable-${$store.state.healthyHabits.table.key}`" :fields="$store.state.healthyHabits.table.data.fields" :items="$store.state.healthyHabits.table.data.items" 
      @row-clicked="rowClick" @row-hovered="rowHovered" @row-unhovered="rowUnhovered" hover foot-clone small show-empty>
          <template #empty>
            <button v-if="!$store.state.healthyHabits.isReadOnlyView" @click="addNewHabit()" class='btn btn-primary' type='button'>{{$t('firstNewHabit')}}</button>
            <span v-else></span>
          </template>
          <template #head()="data">
            <span v-if="data.column === 'description'">
              <div>
                <b-icon-info-circle class="cursor-pointer mx-2" @click="showTableInfoModal = !showTableInfoModal" variant="primary" scale="1.5"></b-icon-info-circle>
                <base-button v-if="!$store.state.healthyHabits.isReadOnlyView" @click="addNewHabit()" class="btn-padding-reduced-table"><b-icon-plus scale="1.3" v-if="tabletMobileVersion"></b-icon-plus>{{tabletMobileVersion ? '' : $t('newHabit')}}</base-button>
              </div>
            </span>
            <span v-else-if="data.column === 'prevDates' && (!$store.state.healthyHabits.setting.invertedCalendarDays ? $store.state.healthyHabits.table.maxDate < getCurrentDateUtc() : true)" class="cursor-pointer" @click="getDataInInterval($store.state.healthyHabits.setting.invertedCalendarDays)">
              <b-icon-caret-right scale="1.5"></b-icon-caret-right>
            </span>
            <span v-else-if="data.column === 'nextDates' && ($store.state.healthyHabits.setting.invertedCalendarDays ? $store.state.healthyHabits.table.maxDate < getCurrentDateUtc() : true)" class="cursor-pointer" @click="getDataInInterval(!$store.state.healthyHabits.setting.invertedCalendarDays)">
              <b-icon-caret-left scale="1.5"></b-icon-caret-left>
            </span>
            <span v-else-if="data.column === 'sliderSection1'">
              <div class="slider-top"><b-icon-caret-left class="slider-left-arrow" @click="sliderClick(0)"></b-icon-caret-left></div>
              <span v-if="currentSliderPosition === 1">{{$t('currentStreak')}}</span>
              <span style="display: inline-block; max-width: 6ch;" v-if="currentSliderPosition === 2">{{$t('totalWeekShort')}}</span>
              <span style="display: inline-block; max-width: 4ch;" v-if="currentSliderPosition === 3">% {{$t('weekShort')}}</span>
            </span>
            <span v-else-if="data.column === 'sliderSection2'">
              <div style="font-weight: 700" @click="showMoreSlider" class="slider-top-center slider-center">{{$t('showMore')}}</div>
              <span v-if="currentSliderPosition === 1">{{$t('bestStreak')}}</span>
              <span style="display: inline-block; max-width: 5ch;" v-if="currentSliderPosition === 2">{{$t('totalMonth')}}</span>
              <span style="display: inline-block; max-width: 4ch;" v-if="currentSliderPosition === 3">% {{$t('month')}}</span>
            </span>
            <span v-else-if="data.column === 'sliderSection3'">
              <div class="slider-top"><b-icon-caret-right class="slider-right-arrow" @click="sliderClick(1)"></b-icon-caret-right></div>
              <span v-if="currentSliderPosition === 1">{{$t('total')}}</span>
              <span style="display: inline-block; max-width: 5ch;" v-if="currentSliderPosition === 2">{{$t('totalYear')}}</span>
              <span style="display: inline-block; max-width: 4ch;" v-if="currentSliderPosition === 3">% {{$t('year')}}</span>
            </span>
            <span :class="{ 'current-date': isCurentDate(data.label) }" v-else-if="data.label"><span>{{getDateNameFieldFormatted(data.label)}}</span><br><span :class="{ 'current-date': isCurentDate(data.label) }">{{getDateFieldFormatted(data.label)}}</span></span>
          </template>
          <template #cell(description)="data">
            <div v-if="$store.state.healthyHabits.isReadOnlyView" name="description">
              <span class="table-description" :name="data.field.key" :title="data.item.description" :style="{color: data.item.color}">{{data.item.description}}</span>
              <b-progress :max="data.item.goal">
                  <b-progress-bar :style="{'background-color': data.item.color}" :value="data.item.accumulatedGoal" :label-html="getProgressLabel(data)"></b-progress-bar>
              </b-progress>
            </div>
            <div v-else name="description">
              <span class="table-description" :title="data.item.description" :name="data.field.key" :style="{color: data.item.color}">{{data.item.description}}</span>
              <b-row>
                <b-col cols="4" lg="1">
                  <b-icon-save class="description-icon-width" v-if="data.item.stored"></b-icon-save>
                </b-col>
                <b-col cols="4" lg="1">
                  <b-icon-trophy-fill :style="{color: data.item.color}" v-if="data.item.goalCompleted" class="description-icon-width"></b-icon-trophy-fill>
                </b-col>
              </b-row>
              <b-progress :max="data.item.goal">
                  <b-progress-bar :style="{'background-color': data.item.color}" :value="data.item.accumulatedGoal" :label-html="getProgressLabel(data)"></b-progress-bar>
              </b-progress>
            </div>
          </template>
          <template #cell(nextDates)="">
          </template>
          <template #cell(prevDates)="">
          </template>
          <template #cell(sliderSection1)="data">
            <div name="slider" v-if="currentSliderPosition === 1" :style="{'color': data.item.currentStreak > 0 ? data.item.color : grayColour}" :class="getSliderCircleClass(data.item, 1)"><span>{{data.item.currentStreak}}</span></div>
            <div :class="$uiHelpers.isMobileBrowser ? 'cell-overflow-fixed-mobile' : 'cell-overflow-fixed'" name="slider" v-if="currentSliderPosition === 2" :style="{'color': data.item.color}"><span>{{getTotalCountWeek(data.item)}}</span></div>
            <div name="slider" v-if="currentSliderPosition === 3" :style="{'color': data.item.color}"><span>{{getTotalCountWeek(data.item, true)}}%</span></div>
          </template>
          <template #cell(sliderSection2)="data">
            <div name="slider" v-if="currentSliderPosition === 1" :style="{'color': data.item.bestStreak > 0 ? data.item.color : grayColour}" :class="getSliderCircleClass(data.item, 2)"><span>{{data.item.bestStreak}}</span></div>
            <div :class="$uiHelpers.isMobileBrowser ? 'cell-overflow-fixed-mobile' : 'cell-overflow-fixed'" name="slider" v-if="currentSliderPosition === 2" :style="{'color': data.item.color}"><span>{{getTotalCountMonth(data.item)}}</span></div>
            <div name="slider" v-if="currentSliderPosition === 3" :style="{'color': data.item.color}"><span>{{getTotalCountMonth(data.item, true)}}%</span></div>
          </template>
          <template #cell(sliderSection3)="data">
            <div name="slider" v-if="currentSliderPosition === 1" :style="{'color': data.item.total > 0 ? data.item.color : grayColour, 'padding-top': getSliderTotalPaddingTop(data.item)}"><span>{{data.item.total}}</span></div>
            <div :class="$uiHelpers.isMobileBrowser ? 'cell-overflow-fixed-mobile' : 'cell-overflow-fixed'" name="slider" v-if="currentSliderPosition === 2" :style="{'color': data.item.color}"><span>{{getTotalCountYear(data.item)}}</span></div>
            <div name="slider" v-if="currentSliderPosition === 3" :style="{'color': data.item.color}"><span>{{getTotalCountYear(data.item, true)}}%</span></div>
          </template>
          <template #cell(actions)="data">
            <div v-if="!$store.state.healthyHabits.isReadOnlyView" name="description">
              <b-row>
                <b-col cols="4">
                   <b-icon-pencil-square :scale="descriptionIconScale" @click="editHabit(data.item.id)" class="cursor-pointer blue description-icon-width"></b-icon-pencil-square>
                </b-col>
                <b-col cols="4">
                  <b-icon-bar-chart-fill :scale="descriptionIconScale" @click="$router.push({ name: 'healthyHabitsStatistics', params: { id: data.item.id } })" class="cursor-pointer gray description-icon-width"></b-icon-bar-chart-fill>
                </b-col>
                <b-col cols="4">
                  <b-icon-trash :scale="descriptionIconScale" @click="itemId = data.item.id; showConfirmDelete = true" v-if="!data.item.stored" class="cursor-pointer red description-icon-width"></b-icon-trash>
                  <b-icon-arrow-clockwise :scale="descriptionIconScale" @click="itemId = data.item.id; unStoreHabit()" v-if="data.item.stored" class="cursor-pointer black description-icon-width"></b-icon-arrow-clockwise>
                </b-col>
              </b-row>
            </div>
          </template>
          <template #foot(sliderSection1)="">
            <div>
              <b-icon-caret-left class="slider-left-arrow" @click="sliderClick(0)"></b-icon-caret-left>
            </div>
          </template>
          <template #foot(sliderSection2)="">
            <div @click="showMoreSlider" class="slider-center">{{$t('showMore')}}</div>
          </template>
          <template #foot(sliderSection3)="">
            <div>
              <b-icon-caret-right class="slider-right-arrow" @click="sliderClick(1)"></b-icon-caret-right>
            </div>
          </template>
          <template #foot()="">
            <span></span>
          </template>
          <template #cell()="data">
            <div class="multiUserCell" :class="{ 'background-current-day': isCurentDate(data.field.key) }" v-if="data.item.isMultiUser">
              <span class="cursor-pointer">
                <!-- <img v-if="$store.state.healthyHabits.setting.imageData" :name="data.field.key" :class="getMultiUserClass($store.state.healthyHabits.setting.habitUserId, data.field.key, data)" :src="$store.state.healthyHabits.setting.imageData" width="30" height="30"> -->
                <div class="letter-multiuser multi-user-initials" :style="getMultiUserStyle($store.state.healthyHabits.setting.habitUserId, data.field.key, data)" :class="getMultiUserClass($store.state.healthyHabits.setting.habitUserId, data.field.key, data)" :name="data.field.key">{{$store.state.healthyHabits.setting.nick}}</div>
              </span>
              <span class="cursor-pointer" v-for="item in data.item.multiUserInfo" :key="`${item.healthyHabitsUserId}-${data.field.key}`">
                <!-- <img v-if="data.item.multiUserInfo.find(info => info.healthyHabitsUserId === item.healthyHabitsUserId).imageData" @click="showMultiUserInfo(item.healthyHabitsUserId, data.field.key, item.nick, data.item)" :id="`${data.item.id}-${item.healthyHabitsUserId}-${data.field.key}`" :name="data.field.key" :class="getMultiUserClass(item.healthyHabitsUserId, data.field.key, data)" :src="data.item.multiUserInfo.find(info => info.healthyHabitsUserId === item.healthyHabitsUserId).imageData" width="30" height="30"> -->
                <div class="letter-multiuser multi-user-initials" :style="getMultiUserStyle(item.healthyHabitsUserId, data.field.key, data)" :class="getMultiUserClass(item.healthyHabitsUserId, data.field.key, data)" @click="showMultiUserInfo(item.healthyHabitsUserId, data.field.key, item.nick, data)" :id="`${data.item.id}-${item.healthyHabitsUserId}-${data.field.key}`" :name="data.field.key">{{item.nick}}</div>
                <b-popover :target="`${data.item.id}-${item.healthyHabitsUserId}-${data.field.key}`" placement="bottom">
                  {{popoverMultiUserInfo.nick}} {{popoverMultiUserInfo.state}}
                </b-popover>
              </span>
            </div>
            <div class="data-color" :class="{'cursor-pointer': !$store.state.healthyHabits.isReadOnlyView, 'cell-overflow-fixed': !$uiHelpers.isMobileBrowser, 'cell-overflow-fixed-mobile': $uiHelpers.isMobileBrowser, 'partial-fill-opacity': data.value < data.item.goal && fillTableMeasurablePartialGoalCompleted(data), 'background-current-day': isCurentDate(data.field.key) }" :style="{color: fillTableMeasurablePartialGoalCompleted(data) ? data.item.color : grayColour}" :name="data.field.key" v-else-if="data.item.measurable">
              <span :name="data.field.key">
                  {{data.value || 0}}
              </span>
              <br>
              <span :name="data.field.key">{{data.item.measureUnit}}</span>
            </div>
            <div :class="{'cursor-pointer': !$store.state.healthyHabits.isReadOnlyView, 'background-current-day': isCurentDate(data.field.key)}" :name="data.field.key" v-else>
              <b-icon-check-lg v-if="data.value === true" :color="data.item.color" :name="data.field.key"></b-icon-check-lg>
              <b-icon-check-lg v-else-if="data.item[data.field.key] === -1" :class="{'cursor-pointer': !$store.state.healthyHabits.isReadOnlyView, 'partial-fill-opacity': true}" :color="data.item.color" :name="data.field.key"></b-icon-check-lg>
              <b-icon-dash scale="2" v-else-if="data.item[data.field.key] === null" :color="data.item.color" :name="data.field.key"></b-icon-dash>
              <b-icon-x-lg v-else :style="{color: grayColour}" :name="data.field.key"></b-icon-x-lg>
            </div>
          </template>
      </b-table>
      <base-modal :value="showTableInfoModal" :title="$t('tableInfoTitle')" @hide="showTableInfoModal = false">
        <p>{{$t('tableInfo')}}</p>
        <p>{{$t('tableInfo8')}} <a href="/" @click.prevent="$store.state.healthyHabits.showTableLegendModal = true">{{$t('tableInfo8-2')}}</a></p>
        <p>{{$t('tableInfo2')}}</p>
        <p>{{$t('tableInfo3')}}</p>
        <p>{{$t('tableInfo6')}}</p>
        <p>{{$t('tableInfo4')}}</p>
        <p>{{$t('tableInfo7')}}</p>
        <p>{{$t('tableInfo8-1')}} <a href="" @click.prevent="$router.push({ name: 'healthyHabitsFaqs' })">{{$t('tableInfo8-2')}}</a></p>
      </base-modal>
      <base-modal width25 :title="$t('whatWantToDo')" :value="showConfirmDelete" @hide="showConfirmDelete = false">
        <div class="text-center">
          <base-button @click="removeHabit()" class="mr-1">{{$t('remove')}}</base-button><base-button @click="storeHabit()">{{$t('store')}}</base-button>
        </div>
      </base-modal>
    </div>
</template>

<script>
import helpers from '@/helpers'
import '@/plugins/vue-touch'
import BaseModal from '@/components/base/BaseModal'
import BaseInput from '@/components/base/forms/BaseInput'
import BaseButton from '@/components/base/buttons/BaseButton'
import HealthyHabitsForm from '@/components/views/healthy-habits/HealthyHabitsForm'
import healthyHabitsMixin from '@/mixins/healthyHabits.mixin'
import { DAILY_GOAL, WEEKLY_GOAL, MONTHLY_GOAL } from '@/constants/healthyHabits'
import { GRAY_400_COLOUR } from '@/constants/colours'
import { BTable, BRow, BCol, BIcon, BProgress, BProgressBar, BPagination, BPopover, BFormCheckbox } from 'bootstrap-vue'
import Sortable from 'sortablejs'
import BaseDialog from '@/components/base/BaseDialog'
import healthyHabitsRepository from '@/repositories/HealthyHabitsRepository'
import { getMonthName } from '@/helpers/date.helpers'
import moment from 'moment'

const TABLET_MOBILE_MAX_WIDTH = 991

export default {
  name: 'healthyHabitsTable',
  directives: {
    sortable: {
      name: 'sortable',
      bind (el, binding, vNode) {
        el._sortable = Sortable.create(el.querySelector('tbody'), {
          ...binding.value,
          onEnd: function (event) {
            if (event.oldIndex !== event.newIndex) {
              vNode.context.updateTableItemsOrder(event.oldIndex, event.newIndex)
            }
          }
        })
      }
    }
  },
   components: {
    BIcon,
    BTable,
    BRow,
    BCol,
    BProgress,
    BProgressBar,
    BaseModal,
    BaseInput,
    BaseButton,
    BPagination,
    HealthyHabitsForm,
    BPopover,
    BFormCheckbox,
    BaseDialog
   },
   created () {
    let _this = this
    window.addEventListener('resize', function () {
      let limitDate = _this.$store.state.healthyHabits.table.maxDate
      _this.$store.state.healthyHabits.table.minDate = new Date(new Date(limitDate).setDate(limitDate.getDate() - _this.tableNumberDaysVisible() + 1))
      _this.updateHeaderFields()
    }, false)
   },
   mixins: [healthyHabitsMixin],
   data () {
    return {
      sortableOptions: {
        chosenClass: 'is-selected',
        swapThreshold: 5,
        fallbackTolerance: 5,
        delay: 100,
        delayOnTouchOnly: true
      },
      popoverMultiUserInfo: {
        nick: null,
        state: null
      },
      id: null,
      key: 0,
      alertClickTimeout: null,
      newMeasurement: null,
      showTableInfoModal: false,
      showingSortOptions: false,
      showingSortDirection: false,
      currentSliderPosition: 1,
      showConfirmDelete: false,
      itemId: null
    }
   },
   computed: {
    grayColour () {
      return GRAY_400_COLOUR
    },
    isMobileReduced () {
      return window.screen.width < 450
    },
		isMobileBrowser () {
      return helpers.isMobileBrowser()
    },
    tabletMobileVersion () {
      return window.screen.width < TABLET_MOBILE_MAX_WIDTH
    },
    currentMonthName () {
      return getMonthName(this.$store.state.healthyHabits.table.maxDate)
    },
    descriptionIconScale () {
      return this.isMobileBrowser ? 1.2 : 1
    }
   },
   methods: {
    trAttributes (data) {
      if (data) {
        return { 'data-id': data.id }
      }
    },
    isCurentDate (date) {
      return moment(date).format('L') === moment().format('L')
    },
    tableSwipe (event) {
      let currentDate = this.getCurrentDateUtc()
      if (event === 'right' && (this.$store.state.healthyHabits.setting.invertedCalendarDays ? this.$store.state.healthyHabits.table.maxDate < currentDate : true)) {
        this.getDataInInterval(!this.$store.state.healthyHabits.setting.invertedCalendarDays)
      } else if (event === 'left' && (!this.$store.state.healthyHabits.setting.invertedCalendarDays ? this.$store.state.healthyHabits.table.maxDate < currentDate : true)) {
        this.getDataInInterval(this.$store.state.healthyHabits.setting.invertedCalendarDays)
      }
    },
    updateTableItemsOrder (oldIndex, newIndex) {
      healthyHabitsRepository.updateTableData({ oldIndex, newIndex }).then((response) => {
        if (response.data) {
          this.sortTableItems(oldIndex, newIndex)
          this.$store.state.healthyHabits.table.key++
        } else {
          this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
        }
      })
    },
    getMultiUserClass (healthyHabitsUserId, date, itemData) {
      let value = healthyHabitsUserId === this.$store.state.healthyHabits.setting.habitUserId ? itemData.item[date] : itemData.item.multiUserData.find(d => d.healthyHabitsUserId === healthyHabitsUserId) ? itemData.item.multiUserData.find(d => d.healthyHabitsUserId === healthyHabitsUserId)[date] : undefined
      let isPassed = (!itemData.item.measurable && value === null) || (itemData.item.measurable && (value > 0 && value < itemData.item.goal))
      let isCompleted = (!itemData.item.measurable && value === true) || (itemData.item.measurable && value >= itemData.item.goal)
      let isPartialCompleted = !isCompleted && ((itemData.item.measurable && this.fillMultiUserTableMeasurablePartialGoalCompleted(itemData, healthyHabitsUserId)) || (!itemData.item.measurable && value === -1))
      let isEmpty = !isPassed && !isPartialCompleted && !isCompleted && !((!itemData.item.measurable && value === true) || (itemData.item.measurable && value >= itemData.item.goal))
      return {'multiUserCellEmpty': isEmpty, 'linear-gradient ': isPassed, 'partial-fill-opacity': isPartialCompleted}
    },
    getMultiUserStyle (healthyHabitsUserId, date, itemData) {
      let value = healthyHabitsUserId === this.$store.state.healthyHabits.setting.habitUserId ? itemData.item[date] : itemData.item.multiUserData.find(d => d.healthyHabitsUserId === healthyHabitsUserId) ? itemData.item.multiUserData.find(d => d.healthyHabitsUserId === healthyHabitsUserId)[date] : undefined
      let isCompleted = (!itemData.item.measurable && value === true) || (itemData.item.measurable && value >= itemData.item.goal)
      let isPartialCompleted = !isCompleted && ((itemData.item.measurable && this.fillMultiUserTableMeasurablePartialGoalCompleted(itemData, healthyHabitsUserId)) || (!itemData.item.measurable && value === -1))
      return {'background-color': isCompleted || isPartialCompleted ? itemData.item.color : null}
    },
    showMultiUserInfo (healthyHabitsUserId, date, nick, itemData) {
      this.$root.$emit('bv::hide::popover')
      let itemValue = itemData.item.multiUserData.find(d => d.healthyHabitsUserId === healthyHabitsUserId) ? itemData.item.multiUserData.find(d => d.healthyHabitsUserId === healthyHabitsUserId)[date] : undefined
      this.popoverMultiUserInfo.nick = nick
      if (itemValue !== undefined) {
        this.popoverMultiUserInfo.nick = nick
        if (!itemData.item.measurable) {
          this.popoverMultiUserInfo.state = itemValue === true ? this.$t('multiUserCompleted') : itemValue === -1 ? this.$t('multiUserPartialCompleted') : itemValue === null ? this.$t('multiUserDayFree') : this.$t('multiUserUncompleted')
        } else {
          this.popoverMultiUserInfo.state = itemValue >= itemData.item.goal ? this.$t('multiUserMeasurableCompleted', {value: itemValue, unit: itemData.item.measureUnit}) : itemValue > 0 && itemValue < itemData.item.goal ? this.$t('multiUserMeasurablePartialCompleted', {value: itemValue, unit: itemData.item.measureUnit, goal: itemData.item.goal}) : this.$t('multiUserUncompleted')
        }
        this.$root.$emit('bv::show::popover', `${itemData.id}-${healthyHabitsUserId}-${date}`)
      } else if (this.fillMultiUserTableMeasurablePartialGoalCompleted(itemData, healthyHabitsUserId)) {
        this.popoverMultiUserInfo.state = this.$t('multiUserPartialCompleted')
      } else {
        this.popoverMultiUserInfo.state = this.$t('multiUserUncompleted')
      }
    },
    fillMultiUserTableMeasurablePartialGoalCompleted (data, healthyHabitsUserId) {
      let item = healthyHabitsUserId === this.$store.state.healthyHabits.setting.habitUserId ? data.item : data.item.multiUserData.find(d => d.healthyHabitsUserId === healthyHabitsUserId)
      if (item === undefined) {
        return false
      }
      let dataKeys = Object.keys(item)
      let dates = []
      if (data.item.goalFrequencyId === DAILY_GOAL) {
        return data.item.goal <= item[data.field.key]
      }
      if (data.item.goalFrequencyId === WEEKLY_GOAL) {
        dates = dataKeys.filter(key => this.checkValidDate(key) && this.getDatesOfWeekFromDate(data.field.key).some(item => item === key))
        return dates.reduce((acc, date) => acc + (item[date] > 0 ? item[date] : 0), 0) >= data.item.goal
      }
      if (data.item.goalFrequencyId === MONTHLY_GOAL) {
        let currentMonth = new Date(data.field.key).getMonth() + 1
        dates = dataKeys.filter(key => this.checkValidDate(key) && currentMonth === parseFloat(key.split('-')[1]))
        return dates.reduce((acc, date) => acc + (item[date] > 0 ? item[date] : 0), 0) >= data.item.goal
      }
    },
    getProgressLabel (data) {
      return `<span style="font-weight: bold;" class="progressBarTable ${data.item.accumulatedGoal >= data.item.goal ? 'green' : ''}">${Math.round((data.item.accumulatedGoal / data.item.goal) * 100)}% ${this.getFrequencyName(data.item.goalFrequencyId)}</span>`
    },
    sortTableItems (oldIndex, newIndex) {
      let habitModified = this.$store.state.healthyHabits.table.data.items[oldIndex]
      habitModified.position = newIndex
      this.$store.state.healthyHabits.table.data.items.filter(h => h.id !== habitModified.id).forEach(item => {
        if (oldIndex < newIndex) {
            item.position = item.position > oldIndex && item.position <= newIndex ? --item.position : item.position
        } else {
            item.position = item.position < oldIndex && item.position >= newIndex ? ++item.position : item.position
        }
      })
      this.$store.state.healthyHabits.table.data.items.sort((a, b) => a.position - b.position)
    },
    getSliderCircleClass (item, position) {
      let circle = false
      let circle1Digit = false
      let circle2Digit = false
      let circle3Digit = false
      let circle4Digit = false
      if (position === 1) {
        circle = item.bestStreak > 0 && item.currentStreak > 0
        circle1Digit = item.currentStreak >= 0 && item.currentStreak < 10
        circle2Digit = item.currentStreak >= 10 && item.currentStreak < 100
        circle3Digit = item.currentStreak >= 100 && item.currentStreak < 1000
        circle4Digit = item.currentStreak >= 1000 && item.currentStreak < 10000
      } else if (position === 2) {
        circle = item.bestStreak > 0 && item.currentStreak >= item.bestStreak
        circle1Digit = item.bestStreak >= 0 && item.bestStreak < 10
        circle2Digit = item.bestStreak >= 10 && item.bestStreak < 100
        circle3Digit = item.bestStreak >= 100 && item.bestStreak < 1000
        circle4Digit = item.bestStreak >= 1000 && item.bestStreak < 10000
      }
      return {circle: circle, 'circle-1-digit': circle1Digit, 'circle-2-digit': circle2Digit, 'circle-3-digit': circle3Digit, 'circle-4-digit': circle4Digit}
    },
    getSliderTotalPaddingTop (item) {
      return item.bestStreak >= 0 && item.bestStreak < 10 ? '0.2em' : item.bestStreak >= 10 && item.bestStreak < 100 ? '0.2em' : item.bestStreak >= 100 && item.bestStreak < 1000 ? '0.4em' : '0.5em'
    },
    rowClick (item, index, event) {
      let targetName = event.target.getAttribute('name')
      let habitUserId = event.target.getAttribute('id')
      if (habitUserId && habitUserId !== this.$store.state.healthyHabits.setting.habitUserId) {
        return
      }

      if (this.$store.state.healthyHabits.isReadOnlyView || this.$store.state.healthyHabits.table.updatingItem || event.target.closest('div[name="description"]') || event.target.closest('div[name="slider"]')) {
        return
      }
      if (!targetName) {
        if (item.measurable) {
          targetName = this.checkValidDate(event.target.querySelector('span').getAttribute('name')) ? event.target.querySelector('span').getAttribute('name') : null
        } else {
          targetName = event.target.parentElement.parentElement.getAttribute('name')
        }
      }
      targetName = targetName || (event.target.firstChild && event.target.firstChild.getAttribute('name') && this.checkValidDate(event.target.firstChild.getAttribute('name')) ? event.target.firstChild.getAttribute('name') : null)
      if (!targetName) return

      let itemValue = this.$store.state.healthyHabits.table.data.items[index][targetName]
      this.$store.state.healthyHabits.table.itemSelectedId = item.id
      this.$store.state.healthyHabits.itemSelected.date = targetName
      this.$store.state.healthyHabits.itemSelected.fromCalendar = false
      if (item.measurable) {
        this.$store.state.healthyHabits.itemSelected.measureUnit = item.measureUnit
        this.$store.state.healthyHabits.itemSelected.currentValue = itemValue || 0
        this.$store.state.healthyHabits.itemSelected.newValue = itemValue
        this.$store.state.healthyHabits.showMeasurableInputModal = true
      } else {
        /*eslint-disable*/
        if (this.$store.state.healthyHabits.setting.allowFreeDays) {
          this.$store.state.healthyHabits.itemSelected.newValue = itemValue === true ? null : itemValue === null ? false : true
        } else {
          this.$store.state.healthyHabits.itemSelected.newValue = !itemValue || itemValue === -1 ? true : false
        }       
        this.sendModifiedData()
      }
    },
    rowHovered (item, index, event) {
      item.showActionButtons = true
    },
    rowUnhovered (item, index, event) {
      item.showActionButtons = false
    },
    addNewHabit () {
      /* if (this.$store.state.healthyHabits.table.data.items.length >= 10) {
        this.$store.dispatch('showInfoAlert', this.$t('maxhealthyHabitsReached'))
        return
      } */
      this.$store.state.healthyHabits.form.predefinedHabit = null
      this.$store.state.healthyHabits.form.show = true
    },
    editHabit (itemId) {
      this.$store.state.healthyHabits.form.predefinedHabit = null
      this.$store.state.healthyHabits.table.itemSelectedId = itemId
      this.$store.state.healthyHabits.form.editing = true
      this.$store.state.healthyHabits.form.show = true
    },
    removeHabit () {
      healthyHabitsRepository.removeTableData({data: {itemId: this.itemId }}).then((response) => {
        if (response.data) {
          this.$store.dispatch('showSuccessAlert', this.$t('changesPerformedCorrectly'))
          this.getHealthyHabitsData()
        } else {
          this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
        }
        this.showConfirmDelete = false
      })
    },
    storeHabit () {
      healthyHabitsRepository.removeTableData({data: {itemId: this.itemId, store: true }}).then((response) => {
        if (response.data) {
          this.$store.dispatch('showSuccessAlert', this.$t('changesPerformedCorrectly'))
          this.getHealthyHabitsData()
        } else {
          this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
        }
        this.showConfirmDelete = false
      })
    },
    unStoreHabit () {
      healthyHabitsRepository.removeTableData({data: {itemId: this.itemId, unStore: true }}).then((response) => {
        if (response.data) {
          this.$store.dispatch('showSuccessAlert', this.$t('changesPerformedCorrectly'))
          this.getHealthyHabitsData()
        } else {
          this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
        }
        this.showConfirmDelete = false
      })
    },
    fillTableMeasurablePartialGoalCompleted (data) {
      let dataKeys = Object.keys(data.item)
      let dates = []
      if (data.item.goalFrequencyId === DAILY_GOAL) {
        return data.item.goal <= data.value
      }
      if (data.item.goalFrequencyId === WEEKLY_GOAL) {
        dates = dataKeys.filter(key => this.checkValidDate(key) && this.getDatesOfWeekFromDate(data.field.key).some(item => item === key))
        return dates.reduce((acc, date) => acc + data.item[date], 0) >= data.item.goal
      }
      if (data.item.goalFrequencyId === MONTHLY_GOAL) {
        let currentMonth = new Date(data.field.key).getMonth() + 1
        dates = dataKeys.filter(key => this.checkValidDate(key) && currentMonth === parseFloat(key.split('-')[1]))
        return dates.reduce((acc, date) => acc + data.item[date], 0) >= data.item.goal
      }
    },
    getDataInInterval (previous) {
      if (previous) {
        let limitDate = new Date(this.$store.state.healthyHabits.table.minDate)
        this.$store.state.healthyHabits.table.minDate = new Date(new Date(limitDate).setDate(limitDate.getDate() - this.tableNumberDaysVisible()))
        this.$store.state.healthyHabits.table.maxDate = new Date(new Date(limitDate).setDate(limitDate.getDate() - 1))
      } else {
        let limitDate = new Date(this.$store.state.healthyHabits.table.maxDate)
        this.$store.state.healthyHabits.table.minDate = new Date(new Date(limitDate).setDate(limitDate.getDate() + 1))
        this.$store.state.healthyHabits.table.maxDate = new Date(new Date(limitDate).setDate(limitDate.getDate() + this.tableNumberDaysVisible()))
      }
      if (this.$store.state.healthyHabits.table.minDate < this.$store.state.healthyHabits.table.minDateServer) {
        this.$store.state.healthyHabits.table.limitDate = this.$store.state.healthyHabits.table.minDateServer
        this.$store.state.healthyHabits.table.prevDates = true
        this.$store.state.healthyHabits.hideLoadingIcon = true
        this.getHealthyHabitsData(null, true)
        this.updateHeaderFields()
      } else {
        this.updateHeaderFields()
      }
    },
    /*
    showSortOptions () {
      this.showingSortOptions = true
    },
     setSort (field) {
      this.$store.state.healthyHabits.table.setting.sortField = field
      this.showingSortOptions = false
      this.showingSortDirection = true
      // send data to server
    },
    setSortDirection (descending) {
      // send data to server
      this.$store.state.healthyHabits.table.setting.sortDescending = descending
      this.showingSortDirection = false
      this.showingSortOptions = false
      this.$root.$emit('bv::hide::popover')
    }, */
    sliderClick (arrowDirection) {
      if (arrowDirection === 0) {
        this.currentSliderPosition = this.currentSliderPosition === 1 ? 3 : this.currentSliderPosition === 3 ? 2 : 1
      } else if (arrowDirection === 1) {
        this.currentSliderPosition = this.currentSliderPosition === 1 ? 2 : this.currentSliderPosition === 2 ? 3 : 1
      }
    },
    showMoreSlider () {
      this.currentSliderPosition = this.currentSliderPosition === 1 ? 2 : this.currentSliderPosition === 2 ? 3 : 1
    }
   },
    mounted () {
      if (this.$route.params.healthyHabitPreselectedId) {
        this.$store.state.healthyHabits.historyPatientId = this.$route.params.historyPatientId
        let _this = this
        setTimeout(() => {
          if (document.querySelectorAll(`tr[data-id="${_this.$route.params.healthyHabitPreselectedId}"]`)[0]) {
            document.querySelectorAll(`tr[data-id="${_this.$route.params.healthyHabitPreselectedId}"]`)[0].classList.add("tr-background-fill")
            setTimeout(() => {
              document.querySelectorAll(`tr[data-id="${_this.$route.params.healthyHabitPreselectedId}"]`)[0].style['background-color'] = 'initial'
              setTimeout(() => {
                document.querySelectorAll(`tr[data-id="${_this.$route.params.healthyHabitPreselectedId}"]`)[0].style.removeProperty("background-color")
                document.querySelectorAll(`tr[data-id="${_this.$route.params.healthyHabitPreselectedId}"]`)[0].classList.remove("tr-background-fill")
              }, 1500);
            }, 2000);
          }
        }, 2000);
      }
      this.id = `healthy-habits-table-${helpers.generateGuid()}`
    }
}
</script>

<style lang="scss">
$tableMobileMaxWidth: 991px;
table[id*="healthy-habits-table"] {
  tr td span {
    display: inline;
  }
  tr {
    height: 72px;
  }
  .progress{
    position: relative;
  }
  .progressBarTable{
    position: absolute;
    display: block;
    width: 100%;
    @media screen and (max-width: $tableMobileMaxWidth) {
      font-size: 0.75rem;
    }
  }
  tr th, tr td {
    max-width: 64px;
    text-align: center;
    vertical-align: middle;
    @include media(mobile, tablets) {
      // width: 34px;
      max-width: 20px;
    }
    tr {
      span {
        display: inline-block;
        width: max-content;
      }
    }
  }
  @media screen and (max-width: $tableMobileMaxWidth) {
    &.table-sm {
      th, td {
        padding-left: 0px;
        padding-right: 0px;
      }
    }
    tr th {
      min-width: 20px;
    }
  }
  tr > th[aria-label="Next Dates"], tr > th[aria-label="Prev Dates"] {
    @include media(mobile) {
      width: auto !important;
      min-width: 5px !important;
      max-width: 5px !important;
    }
    min-width: 12px !important;
    width: 35px;
  }
  tr > th[aria-label="Actions"] {
    @include media(mobile) {
      min-width: 35px !important;
      max-width: 35px !important;
    }
  }
}
.background-editing-row {
  animation: blinker 3s cubic-bezier(.5, 0, 1, 1) infinite alternate;
}
@keyframes blinker { 
  0%{background-color: #8080806e;}
  50%{background-color: initial;}
  100%{background-color: #8080806e;}
}
.popover-options-row > div > div{
    margin-bottom: .5rem;
}
.circle {
  display: inline-block;
  padding: 0.1em 0.4em 0.1em 0.4em;
  border-radius: 50%;
  background-color: white;
  text-align: center;
  border: 3px solid;
}
.circle span {
  font-size: 1em;
}
.slider-container {
  @media screen and (max-width: $tableMobileMaxWidth) {
    width: calc(100% + 2px);
    margin-left: 2px;
  }
  width: 100%;
  height: 5px;
  background-color: $gray-400;
  position: relative;
}
.slider-container-left-side {
  height: 5px;
  background-color: $gray-400;
  position: relative;
  margin-left: 25px;
  @media screen and (max-width: $tableMobileMaxWidth) {
    margin-left: 15px !important;
    width: calc(100% - 9px);
  }
}
.slider-container-right-side {
  // width: 40px;
  height: 5px;
  background-color: $gray-400;
  position: relative;
  margin-right: 25px;
  @media screen and (max-width: $tableMobileMaxWidth) {
    margin-right: 12px !important;
  }
}
.slider-circle {
  display: inline-block;
  vertical-align: middle;
  width: 17px;
  height: 17px;
  background-color: white;
  border: solid 1px black;
  border-radius: 50%;
  position: absolute;
  top: -5px;
  left: -1px;
  @media screen and (max-width: $tableMobileMaxWidth) {
    width: 13px;
    height: 13px;
    top: -4px;
  }
}
.circle-1-digit {
  padding: 0.2em 0.6em 0.1em 0.6em !important;
}
.circle-2-digit {
  padding: 0.2em 0.4em 0.1em 0.4em !important;
}
.circle-3-digit {
  @media screen and (max-width: $tableMobileMaxWidth) {
      span {
        font-size: 0.9em;
      }
      max-width: 33px;
  }
  padding: 0.4em 0.4em 0.4em 0.4em !important;
}
.circle-4-digit {
  @media screen and (max-width: $tableMobileMaxWidth) {
      span {
        font-size: 0.9em;
      }
      max-width: 33px;
  }
  padding: 0.5em 0.5em 0.5em 0.5em !important;
}
th[aria-label="Slider Section1"], th[aria-label="Slider Section2"], th[aria-label="Slider Section3"] {
  position: relative;
  width: 65px;
  padding: 0px;
  min-width: 34px !important;
  @media screen and (max-width: $tableMobileMaxWidth) {
    width: 25px !important;
    max-width: 34px !important;
  }
}
th[aria-label="Description"] {
  width: 278px !important;
  max-width: 278px !important;
  @media screen and (max-width: $tableMobileMaxWidth) {
    width: 100px !important;
    max-width: 100px !important;
  }
}
.table-description{
  cursor: default;
  // max-height: 48px !important;
  display: block !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  @media screen and (max-width: $tableMobileMaxWidth) {
    // max-height: 36px !important;
  }
}
th[aria-label="Slider Section3"] {
  @media screen and (max-width: $tableMobileMaxWidth) {
    min-width: 30px !important;
  }
}
@media screen and (max-width: $tableMobileMaxWidth) {
  /* th[aria-label="Slider Section1"], th[aria-label="Slider Section2"] {
    padding-right: 3px !important;
  } */
  th[aria-label="Slider Section1"], th[aria-label="Slider Section2"], th[aria-label="Slider Section3"] {
    font-size: 10px !important;
  }
}
@media screen and (min-width: $tableMobileMaxWidth) {
th[aria-label="Description"] {
    min-width: 160px !important;
  }
}
.description-icon-width{
  width: 16px;
  height: 16px;
  @media screen and (max-width: $tableMobileMaxWidth) {
    width: 15px;
    height: 15px;
  }
}
div[name="description"] div.row{
  justify-content: center;
}
.btn-padding-reduced-table{
    padding: 0.4rem 1rem !important;
    @media screen and (max-width: $tableMobileMaxWidth) {
        padding: 0.1rem 0.3rem !important;
    }
}
.cell-overflow-fixed{
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 64px;
  display: inline-block !important;
  white-space: nowrap;
  @media screen and (max-width: $tableMobileMaxWidth) {
      max-width: 49px;
  }
}
.cell-overflow-fixed-mobile{
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 49px;
  display: inline-block !important;
  white-space: nowrap;
}
tfoot tr{
  height: auto !important;
}
.slider-center{
  cursor: pointer;
  color: $gray-600;
  @media screen and (max-width: $tableMobileMaxWidth) {
    font-size: 7.3px;
  }
}
.slider-left-arrow{
  color: $gray-600;
  cursor: pointer;
}
.slider-right-arrow{
  color: $gray-600;
  cursor: pointer;
}
.slider-top{
  position: absolute;
  top: -15px;
  left: 0;
  right: 0; 
}
.slider-top-center{
  position: absolute;
  top: -13px;
  left: 0;
  right: 0; 
}
.current-month-table{
  text-align: center;
  color: $blue;
  font-weight: bold;
  @media screen and (min-width: $tableMobileMaxWidth) and (max-width: 1199px) {
    margin-left: 45px;
  }
  @media screen and (min-width: 1200px) {
    margin-left: 87px;
  }
}
.current-month-table-mobile{
  float: right;
  padding-right: 34vw;
}
.tr-background-fill{
    background-color: white;
    transition: background-color 1000ms linear;
}
.tr-background-unfill{
    background-color: none;
    transition: background-color 1000ms linear;
}
.multiUserCell{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  span{
      img{
        border-radius: 50%;
        flex-basis: 50%;
      }
      div{
        background-color: $gray;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        flex-basis: 50%;
        line-height: 30px;
      }
  }
}
img.multiUserCellEmpty{
  filter: grayscale(100%)
}
div.multiUserCellEmpty{
  background-color: $gray !important;
}
.multiUserCellCompleted{
  background-color: $green !important;
}
.letter-multiuser{
  color: white;
}
.multi-user-initials{
  font-weight: bold;
  overflow: hidden;
}
.current-date{
  font-weight: bold;
  color: $blue;
}
.data-color{
  color: $gray-600;
  font-weight: bold;
}
td:has(> div.background-current-day) {
  background-color: rgba(255, 255, 255, 0.5);
}
tbody {
  tr:first-child {
    td:has(> div.background-current-day) {
      border-top-left-radius: $border-radius;
      border-top-right-radius: $border-radius;
    }
  }
  tr:last-child {
    td:has(> div.background-current-day) {
      border-bottom-left-radius: $border-radius;
      border-bottom-right-radius: $border-radius;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/views/healthy-habits/HealthyHabitsTable.vue